import { SWReactIcons } from "@similarweb/icons";

import { translate } from "app/filters/i18nFilter";

import * as SC from "./styles";

export const EmptyRecent = () => (
    <SC.Wrapper>
        <SC.Container>
            <SC.Title>
                <SWReactIcons
                    iconName="mountain-full"
                    size="lg"
                />
                <span>{translate("limited-domains.autocomplete.start-with-project.subtitle")}</span>
            </SC.Title>
            <SC.Text>{translate("limited-domains.autocomplete.firstland.description")}</SC.Text>
        </SC.Container>
    </SC.Wrapper>
);
